'use server'

import { apiRequest, ApiResponse } from '../request'

const BASE = 'email-preferences'

export type EmailCategoryGroup =
    | 'security'
    | 'financial'
    | 'subscription'
    | 'bookings'
    | 'medical'
    | 'hospital'
    | 'sales'
    | 'administrative'
    | 'hr'
    | 'system'

export type EmailAudience = 'INTERNAL' | 'CLIENT' | 'PARTNER'

export interface EmailPreference {
    key: string
    label: string
    description: string
    group: EmailCategoryGroup
    audience: EmailAudience
    /** Não pode ser desligado: sem ele o usuário perde o acesso à conta. */
    alwaysOn?: boolean
    enabled: boolean
}

export interface EmailPreferencesResponse {
    groups: Record<EmailCategoryGroup, { label: string; description: string }>
    categories: EmailPreference[]
}

export async function getEmailPreferences(): Promise<ApiResponse<EmailPreferencesResponse>> {
    return apiRequest<EmailPreferencesResponse>(BASE, {})
}

export async function updateEmailPreferences(
    preferences: { category: string; enabled: boolean }[]
): Promise<ApiResponse<EmailPreference[]>> {
    return apiRequest<EmailPreference[]>(BASE, { data: { preferences } }, 'patch')
}

export async function setAllEmailPreferences(
    enabled: boolean
): Promise<ApiResponse<EmailPreference[]>> {
    return apiRequest<EmailPreference[]>(`${BASE}/all`, { data: { enabled } }, 'put')
}
